import { render, staticRenderFns } from "./DashboardTile.vue?vue&type=template&id=2cd68547&"
import script from "./DashboardTile.vue?vue&type=script&lang=js&"
export * from "./DashboardTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cd68547')) {
      api.createRecord('2cd68547', component.options)
    } else {
      api.reload('2cd68547', component.options)
    }
    module.hot.accept("./DashboardTile.vue?vue&type=template&id=2cd68547&", function () {
      api.rerender('2cd68547', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/scheduling/reports/DashboardTile.vue"
export default component.exports